var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.2063C17.85 12.2063 20.1657 9.89063 20.1657 7.04063C20.1657 4.19063 17.85 1.875 15 1.875C12.15 1.875 9.83442 4.19063 9.83442 7.04063C9.83442 9.89063 12.15 12.2063 15 12.2063ZM15 3.75C16.8094 3.75 18.2907 5.22188 18.2907 7.04063C18.2907 8.85 16.8188 10.3313 15 10.3313C13.1907 10.3313 11.7094 8.85938 11.7094 7.04063C11.7188 5.22188 13.1907 3.75 15 3.75ZM23.6625 28.125C23.6625 28.125 23.4844 21.4219 20.2407 18.1781L21.4125 28.125H8.57817L9.75005 18.1781C6.51567 21.4219 6.33755 28.125 6.33755 28.125H2.59692C2.59692 28.125 3.00942 25.6219 3.86255 23.175C5.7188 17.8688 8.8688 14.0344 15 14.0344C21.1313 14.0344 24.2813 17.8781 26.1375 23.1844C26.9907 25.6313 27.4125 28.1344 27.4125 28.1344H23.6625V28.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/User-icon.8bc19fbc8c439594d1ddcb312b585d52.svg";
export { ForwardRef as ReactComponent };